import React from 'react';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import Cookies from 'js-cookie';
import Auth from '@chotot/auth';
import { config } from '@app/config';
import { loadSavedAd } from '@app/components/GridAds/SaveAd/action';
import PlaceHolder from '@chotot/appwrapper-placeholder';
import { styled } from 'linaria/react';
import { fetchAppWrapperManifest } from '@chotot/appwrapper-utils';
const CustomErrorPage = dynamic(() => import('@app/pages/_error'));
const Main = /*#__PURE__*/styled("main")({
  name: "Main",
  class: "mi85h81"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1kiracd"
});
const site = {
  siteName: 'job',
  href: `${config.jobURL}`,
  actions: {
    search: text => {
      if (typeof window !== 'undefined') {
        let listingParams = Cookies.get('listingParams');
        if (!listingParams) {
          listingParams = '{"region":"toan-quoc"}';
        }
        listingParams = JSON.parse(listingParams);
        let url = listingParams.region;
        if (listingParams.subRegion) {
          url = `${url}/${listingParams.subRegion}`;
        }
        url = `${config.jobURL}/${url}/mua-ban?q=${text}`;
        Cookies.set('searchNavigation', '1');
        window.location.href = url;
      }
    }
  }
};
function withLayout(Child) {
  class WrappedComponent extends React.Component {
    static async getInitialProps(context) {
      const pageProps = await Child.getInitialProps(context);
      try {
        const manifest = await fetchAppWrapperManifest({
          env: config.newEnv,
          vertical: site.siteName,
          useCache: true,
          debug: process.env.NODE_ENV === 'development'
        });
        return {
          ...pageProps,
          manifest
        };
      } catch (e) {
        console.log('Error while fetching manifest', e);
        return {
          ...pageProps
        };
      }
    }
    state = {
      auth: {}
    };
    successCallBack = async data => {
      const {
        dispatch
      } = this.props;
      const {
        user,
        shop
      } = data;
      // Auth Obj for App Wrapper
      this.setState({
        auth: {
          ...user,
          shop
        }
      });
      // pushPageMetadataIsLogin({ user: { ...data }, authenticated: true });
      await dispatch(loadSavedAd());
    };
    errorCallBack = async () => {
      // pushPageMetadataIsLogin({ auth: { authenticated: false } });
    };
    onSilentLoginDone = () => {
      // By default, Auth will reload the page when silent login done
      // We do not need to reload the page. Because homepage call public api.
    };
    render() {
      const {
        err,
        manifest = {}
      } = this.props;
      const urlRemoteHeader = manifest.headerjs;
      const urlRemoteHeaderBackup = manifest.headerjsfallback;
      const urlRemoteHeaderCss = manifest.headercss;
      const urlRemoteFooter = manifest.footerjs;
      const urlRemoteFooterCss = manifest.footercss;
      const {
        auth
      } = this.state;
      if (err) {
        return <CustomErrorPage statusCode={err.statusCode} />;
      }
      return <Container>
          <Head>
            <link rel="preload" href={urlRemoteHeaderCss} as="style" />
            <link rel="stylesheet" href={urlRemoteHeaderCss} key="headercss" />
            <link rel="preload" href={urlRemoteFooterCss} as="style" />
            <link rel="stylesheet" href={urlRemoteFooterCss} key="footercss" />
          </Head>
          <Auth env={config.newEnv} successCallBack={this.successCallBack} errorCallBack={this.errorCallBack} clientId={config.chototId.clientId} onSilentLoginDone={this.onSilentLoginDone}>
            {() => <div />}
          </Auth>
          <PlaceHolder url={urlRemoteHeader} backupUrl={urlRemoteHeaderBackup} manifest={manifest} env={config.legacyEnv} auth={auth} user={auth.user} shop={auth.shop} site={site.siteName} searchAction={site.actions.search} useCacheRemoteComp {...manifest?.awConfig} />
          <Main>
            <Child {...this.props} />
          </Main>
          <PlaceHolder site={site.siteName} url={urlRemoteFooter} manifest={manifest} env={config.legacyEnv} loader={<div />} fallback={<div />} useCacheRemoteComp {...manifest?.awConfig} />
        </Container>;
    }
  }
  return WrappedComponent;
}
export default withLayout;

require("../../.linaria-cache/src/hocs/withLayout.linaria.module.css");